export enum IframeAllowValue {
  Fullscreen = "fullscreen",
}

export enum VideoSourceUrl {
  Facebook = "www.facebook.com",
  ScmpWidget = "widgets.scmp.com",
  Youtube = "www.youtube.com",
}

export const SCMPMultimediaUrl = "multimedia.scmp.com";
